module.exports = __webpack_public_path__ + "img/socooc-partnership-hero.1adb4b8f.png";